import PersonalPropertyCard from '@/pages/mortgage/components/PersonalProperty';
import React from 'react';

interface PropertyListProps {
  propertyData: any;
  selectedProperties: any;
  showCheckbox?: boolean;
  onSelect?: any;
  formSource?: string;
}

const PropertyList: React.FC<PropertyListProps> = ({
  propertyData,
  selectedProperties,
  showCheckbox = false,
  onSelect,
  formSource = 'refinance',
}) => {
  return (
    <div>
      {propertyData.map((property: any, index: number) => {
        return (
          <div
            key={property.id}
            style={{
              width: '100%',
              marginBottom: '1rem',
            }}
          >
            <PersonalPropertyCard
              property={property}
              showCheckbox={showCheckbox}
              isSelected={selectedProperties.includes(property.id)}
              onSelect={() => onSelect(property.id)}
              formSource={formSource}
            />
          </div>
        );
      })}
    </div>
  );
};

export default PropertyList;
